<template>
  <section class="blog-feature">
    <h1 class="blog-feature__heading">
      Journal,<br />
      Latest Posts
    </h1>
    <div class="blog-feature__articles">
      <ArticleCard v-for="article in articles" :key="article.handle" v-bind="article" ref="cards" />
    </div>
  </section>
</template>

<script>
import ArticleCard from './article-card.vue'

export default {
  components: {
    ArticleCard,
  },

  props: {
    articles: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeCardIndex: 0,
      intersectionObserver: null,
      cardVisibility: {},
      elTop: null,
      elHeight: null,
    }
  },

  computed: {
    activeArticle() {
      return this.articles[this.activeCardIndex]
    },
  },

  created() {
    // this.intersectionObserver = new IntersectionObserver(entries => {
    //   entries.forEach(entry => {
    //     const handle = entry.target.__vue__.handle
    //     this.cardVisibility[handle] = entry.isIntersecting
    //       ? true
    //       : false
    //   })
    // })
  },

  // mounted () {
  //   this.cardVisibility = this.$refs.cards.reduce((cards, card) => {
  //     cards[card.handle] = false
  //     return cards
  //   }, {})

  //   this.$refs.cards.forEach(card => {
  //     this.intersectionObserver.observe(card.$el)
  //   })

  //   window.addEventListener('scroll', (e) => {
  //     const elementHeight = this.$el.offsetHeight
  //     const scrolledFromTop = window.scrollY - this.$el.offsetTop
  //     const topScrolledPercentage = scrolledFromTop / elementHeight
  //     const bottomScrolledPercentage = (scrolledFromTop + window.innerHeight) / elementHeight
  //     const start = 5 * topScrolledPercentage
  //     const end = 5 * bottomScrolledPercentage
  //     const activeIndex = (Math.ceil(end - ((end - start) / 2))) - 1
  //     this.activeCardIndex = activeIndex < this.articles.length ? Math.max(0, activeIndex) : Math.min(this.articles.length - 1, activeIndex)
  //   })
  // }
}
</script>

<style lang="scss" scoped>
@import '~styles/frontend/variables';
@import '~styles/frontend/mixins';

.blog-feature {
  --blog-feature-columns: 23;
  --blog-feature-column-template_mob: 2fr 5fr 2fr;
  --blog-feature-card-min-height: 350px;

  @media (max-width: 700px) {
    --blog-feature-columns: 8;
    --blog-feature-card-min-height: 500px;
  }

  position: relative;

  &__heading {
    @include uppercase;

    text-align: center;
    padding: 20px $inset;
    border-top: 1px solid;
    border-bottom: 1px solid;
  }

  &__articles {
    position: relative;
  }

  &__image-track {
    @include absolute-cover;

    display: grid;
    grid-template-columns: repeat(var(--blog-feature-columns), 1fr);
    align-items: start;
    padding: 0 $inset;
    bottom: 0;
    pointer-events: none;

    @media (max-width: 700px) {
      grid-template-columns: var(--blog-feature-column-template_mob);
    }
  }

  &__image-container {
    position: sticky;
    top: $header_height_desktop;
    grid-column: span 7 / -4;
    padding: 40px 0;

    @media (max-width: 1000px) {
      grid-column: span 9 / -3;
    }

    @media (max-width: 700px) {
      grid-column: 3 / -3;
      display: flex;
      align-items: flex-end;
      min-height: var(--blog-feature-card-min-height);
    }
  }

  &__image {
    transition: opacity 0.6s ease 0.15s;
  }

  &__image-link {
    display: block;
    pointer-events: auto;
  }
}
</style>
